import { ApplicationInsights } from '@microsoft/applicationinsights-web'

const key = document.head.querySelector('meta[name="instrumentation-key"]')
if (key) {
    const appInsights = new ApplicationInsights({
        config: {
            instrumentationKey: key.content
        }
    })

    appInsights.loadAppInsights()
    appInsights.trackPageView() // Manually call trackPageView to establish the current user/session/pageview
}
